var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadingSpinner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 7.5C66.2108 7.5 83 24.2893 83 45C83 65.7108 66.2108 82.5 45.5 82.5C24.7893 82.5 8 65.7108 8 45C8 24.2893 24.7893 7.5 45.5 7.5Z",
    stroke: "#CFE1F2",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 7.5C66.2108 7.5 83 24.2893 83 45",
    stroke: "#06BCFF",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadingSpinner);
export default __webpack_public_path__ + "static/media/UploadingSpinner.a8a0c817bd24c9e48667053077e5b5f0.svg";
export { ForwardRef as ReactComponent };